import React, { useRef } from "react";
import { aiRobotImg, githubImg } from "../utils";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { animateWithGsap } from "../utils/animations";

const HowItWorks = () => {
  const videoRef = useRef();

  useGSAP(() => {
    gsap.from("#chip", {
      scrollTrigger: {
        trigger: "#chip",
        start: "20% bottom",
      },
      opacity: 0,
      scale: 2,
      duration: 2,
      ease: "power2.inOut",
    });

    animateWithGsap(".g_fadeIn", {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power2.inOut",
    });
  }, []);

  return (
    <section className="common-padding">
      <div className="screen-max-width max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Chip Image - Responsive */}
        <div id="chip" className="flex justify-center w-full my-6 sm:my-4">
          <img
            src={aiRobotImg}
            alt="AI ROBOT"
            className="w-[150px] sm:w-[200px] md:w-[300px] md:-mt-28"
          />
        </div>

        {/* Title & Subtitle */}
        <div className="flex flex-col items-center text-center">
          <h2 className="hiw-title text-xl sm:text-2xl md:text-6xl font-bold">
            Artificial Intelligence Engineer
            <br /> Github Contributor
          </h2>

          <p className="hiw-subtitle text-gray-400 text-base sm:text-lg mt-2">
            {/* Placeholder for subtitle */}
          </p>
        </div>

        {/* Frame Image + Github Commits (Fixed Spacing for Mobile) */}
        <div className="mb-6 sm:mb-10 sm:-mt-32 md:-mt-72  flex flex-col items-center">
          <div className="relative overflow-visible rounded-lg">
            <img
              src={githubImg}
              alt="frame"
              className="w-[90%] sm:w-[500px]  sm:mt-0 -mt-40 object-cover rounded-lg shadow-lg"
            />
          </div>

          <p className="text-gray-400 font-semibold text-center text-sm sm:text-lg mt-4 md:-mt-14">
            Github Commits
          </p>
        </div>

        {/* Responsive Text Section */}
        <div className="hiw-text-container grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 sm:mt-8">
          {/* Left Text */}
          <div className="flex flex-col g_fadeIn text-center md:text-left">
            <p className="hiw-text text-base sm:text-lg leading-relaxed">
              GATE (Graduate Aptitude Test in Engineering) All India Rank - 1200 out of 60,000.{" "}
              <span className="text-white">
                Research opportunities in Artificial Intelligence and Machine Learning domains.
              </span>
              .
            </p>

            <p className="hiw-text text-base sm:text-lg mt-4">
              <span className="text-white">
                9 CPGA out of 10 in UG Degree.
              </span>
            </p>
          </div>

          {/* Right Section - Motivational Text */}
          <div className="flex flex-col items-center text-center g_fadeIn">
            <p className="text-base sm:text-lg text-gray-400">🚀 MAFAZ</p>
            <p className="hiw-bigtext text-lg sm:text-2xl font-extrabold text-white">
              Aiming for Top Institutes to Work with.
            </p>
            <p className="text-base sm:text-lg text-gray-400"></p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;